import { render, staticRenderFns } from "./PositionCapacityTrigger.vue?vue&type=template&id=5b330183&scoped=true"
import script from "./PositionCapacityTrigger.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionCapacityTrigger.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PositionCapacityTrigger.vue?vue&type=style&index=0&id=5b330183&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b330183",
  null
  
)

export default component.exports